import { ComponentProps } from 'react';

import { MoreVert } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';

import { MenuSystemSessionBadge } from 'components/header/menu-system/MenuSystemSessionBadge';
import { useApplicationContext } from 'context/ApplicationContext';
import { useBreakpoints } from 'hooks/useBreakpoints';

type MenuSystemButton = {
    onClick: ComponentProps<typeof Button>['onClick'];
};

/**
 * Botão responsável por abrir o menu de módulos.
 */
export function MenuSystemButton({ onClick }: MenuSystemButton) {
    const { isUpSm } = useBreakpoints();
    const { user, store } = useApplicationContext();

    return (
        <MenuSystemSessionBadge>
            <Button
                onClick={onClick}
                sx={{
                    'gap': 1,
                    'height': 40,
                    'minWidth': 40,
                    'border': 1,
                    'borderRadius': 1.5,
                    'borderColor': (theme) => theme.lighten(theme.palette.secondary.main, 0.2),
                    'backgroundColor': (theme) => theme.lighten(theme.palette.secondary.main, 0.075),
                    '&:hover': {
                        borderColor: (theme) => theme.lighten(theme.palette.secondary.main, 0.3),
                        backgroundColor: (theme) => theme.lighten(theme.palette.secondary.main, 0.15),
                    },
                }}
            >
                {isUpSm && (
                    <Box
                        sx={{
                            color: 'common.white',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'end',
                            justifyContent: 'center',
                            gap: 0.4,
                        }}
                    >
                        <Typography variant="button" component="div" color="inherit" lineHeight={1}>
                            {user.dsUsuario}
                        </Typography>

                        <Typography variant="caption" component="div" color="inherit" lineHeight={1}>
                            {store.dsNomeFantasia}
                        </Typography>
                    </Box>
                )}

                <MoreVert sx={{ color: 'common.white' }} />
            </Button>
        </MenuSystemSessionBadge>
    );
}
